import React, { useState } from "react";
import Project from "./Project"; // Your existing Project component

export default function ToggleProjectView({ projects }) {
	// Group projects by year and goal
	const groupedProjects = projects.reduce((acc, project) => {
		const key = `${project.year}-${project.goal}`;
		if (!acc[key]) {
			acc[key] = {
				year: project.year,
				goal: project.goal,
				projects: [],
			};
		}
		acc[key].projects.push(project);
		return acc;
	}, {});

	return (
		<div className="projects-container">
			{Object.values(groupedProjects).map((group, idx) => (
				<ToggleGroup key={idx} group={group} />
			))}
		</div>
	);
}

function ToggleGroup({ group }) {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<div className="toggle-group">
			<button className="toggle-button" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen}>
				<span className="toggle-icon">{isOpen ? "−" : "+"}</span>
				<span className="toggle-title">
					{group.year} - {group.goal}
				</span>
				<span className="toggle-line"></span>
			</button>

			{isOpen && (
				<div className="projects-grid">
					{group.projects.map((project, ix) => (
						<Project key={ix} item={project} ix={ix} />
					))}
				</div>
			)}
		</div>
	);
}
